import {styled} from '@volkswagen-onehub/components-core';
import React, {useContext, useEffect, useState} from 'react';
import { BasicDealerData, DealerData, VehicleData } from '../../../types';
import { useDealersStore } from '../../../utils/use-dealers-store';
import { VehicleContext } from '../../../utils/vehicle-context';
import DealerInformation from '../../DealerInformation';

const CardDealerInterface = styled.div`
  grid-area: dealer;
  display: flex;
  justify-content: flex-start;
  margin: 0;
  padding: 0 0 ${(props) => props.theme.size.dynamic0020};
  align-items: center;

  span {
    &:last-child {
      display: flex;
    }
  }
`;

const CardDealer: React.FC = () => {
  const vehicle = useContext(VehicleContext) as VehicleData;
  const { allDealers: dealers } = useDealersStore();
  const [dealer, setDealer] = useState<
    DealerData | BasicDealerData | null
  >(null);
  const {dealer_id} = vehicle;

  useEffect(() => {
    if (!dealer) {
      setDealer(vehicle.dealer_info);
    }
  }, [dealer]);

  useEffect(() => {
    if (!dealer_id || !dealers) return;
    dealers.map((d) => {
      if (d.static_dealer_id == dealer_id) {
        setDealer(d);
      }
    });
  }, [dealer_id, dealers]);

  return (
    <CardDealerInterface>
      {dealer && <DealerInformation dealer={dealer} />}
    </CardDealerInterface>
  );
};

export default CardDealer;
